// The React Compiler mis-compiles this factory: its inner `use*` hooks close over the factory's
// mutable `listeners` array, and the compiler outlines the `.map`/`.forEach` callbacks to module
// scope, where `listeners` is not defined — a `ReferenceError` at runtime. Opt the whole file out
// of the compiler (memoizing these thin wrappers adds no value anyway). See `"use no memo"`.
'use no memo';
import { useCallback, useEffect } from 'react';
/**
 * Returns a coupled pair of hooks that can be used to emit and subscribe to arbitrary events
 *
 * @example
 * const {useEmit, useListener} = createSubscribableEvent();
 *
 * const EmitterComponent = () => {
 *  const emit = useEmit();
 *
 *  return <button onClick={emit}>Emit</button>;
 * };
 *
 * const ListenerComponent = () => {
 *  useListener(() => {
 *      // react to the event (it carries no payload)
 *  });
 *
 *  return null;
 * };
 */
export const createSubscribableEvent = () => {
    const listeners = new Set();
    const useEmit = () => {
        const emit = useCallback(() => {
            listeners.forEach(sub => sub());
        }, []);
        return emit;
    };
    const useListener = (listener) => {
        useEffect(() => {
            listeners.add(listener);
            return () => {
                listeners.delete(listener);
            };
        }, [listener]);
    };
    return { useEmit, useListener };
};
